import AssetToken from '@apps/maha/admin/tokens/asset'
import AssetCard from '@apps/maha/admin/cards/asset'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Copyright)',
  collection: {
    endpoint: '/api/admin/assets',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Asset)', key: 'original_file_name', primary: true, format: AssetToken },
      { label: 't(Copyrighted)', key: 'is_copyrighted', collapsing: true, primary: true, format: 'check_times' }
    ],
    card: {
      title: 'original_file_name',
      format: (asset) => <AssetCard asset={ asset } />
    },
    defaultFilter: {
      $and: [
        { content_type: { $lk: 'image' } },
        { id: { $in: props.assets.map(asset => asset.id) } }
      ]
    },
    defaultSort: { key: 'file_name', order: 'asc' },
    empty: {
      svg: 'image',
      title: 't(No Assets)',
      text: 't(You have not yet uploaded any assets for any variants of this social campaign)'
    },
    entity: 'asset',
    selectable: true,
    batch: {
      batch_type: 'assets',
      tasks: [
        { 
          label: 't(Mark as Copyrighted)', 
          svg: 'check',
          action: 'mark',
          refresh: '/admin/assets'
        },
        { 
          label: 't(Unmark as Copyrighted)', 
          svg: 'x',
          action: 'unmark',
          refresh: '/admin/assets'
        }
      ]
    },
    recordTasks: (record) => [
      {
        label: record.is_copyrighted ? 't(Unmark as Copyrighted)' : 't(Mark as Copyrighted)',
        svg: record.is_copyrighted ? 'x' : 'check',
        request: {
          endpoint: `/api/admin/assets/${record.id}/copyright`,
          method: 'PATCH',
          body: {
            is_copyrighted: !record.is_copyrighted
          },
          onSuccess: () => context.flash.set('success', 't(Successfully updated copyright status)'),
          onFailure: () => context.flash.set('error', 't(Unable to update copyright status)')
        }
      }
    ]
  }
})

const mapResources = (props, context) => ({
  assets: `/api/admin/truevail/admin/templates/${props.template.id}/copyright`
})

export default Panel(mapResources, mapPropsToPanel)
